import { render, staticRenderFns } from "./BuyPurchaseHistory.vue?vue&type=template&id=d343e412&scoped=true&"
import script from "./BuyPurchaseHistory.vue?vue&type=script&lang=js&"
export * from "./BuyPurchaseHistory.vue?vue&type=script&lang=js&"
import style0 from "./BuyPurchaseHistory.vue?vue&type=style&index=0&id=d343e412&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d343e412",
  null
  
)

export default component.exports